import { mapScopeKeyToLabel } from 'legacy/lut/components/widgets/public/partner360/composedReport/configs'

import { ScopeSelectKeys } from '../../../../models'

const allValue = { value: ScopeSelectKeys.All, label: mapScopeKeyToLabel[ScopeSelectKeys.All] }

const manualValue = {
  value: ScopeSelectKeys.Manual,
  label: mapScopeKeyToLabel[ScopeSelectKeys.Manual],
}

const manualValueGlobal = {
  value: ScopeSelectKeys.ManualGlobal,
  label: mapScopeKeyToLabel[ScopeSelectKeys.ManualGlobal],
}

export const dataForCommercials = [
  allValue,
  {
    value: ScopeSelectKeys.WWTopOpsPartners,
    label: mapScopeKeyToLabel[ScopeSelectKeys.WWTopOpsPartners],
  },
  {
    value: ScopeSelectKeys.WWTopBpsPartners,
    label: mapScopeKeyToLabel[ScopeSelectKeys.WWTopBpsPartners],
  },
  {
    value: ScopeSelectKeys.MarketOpsTopPartners,
    label: mapScopeKeyToLabel[ScopeSelectKeys.MarketOpsTopPartners],
  },
  {
    value: ScopeSelectKeys.MarketBpsTopPartners,
    label: mapScopeKeyToLabel[ScopeSelectKeys.MarketBpsTopPartners],
  },
  manualValue,
  manualValueGlobal,
]

export const dataForDistributors = [
  allValue,
  {
    value: ScopeSelectKeys.TopDistributors,
    label: mapScopeKeyToLabel[ScopeSelectKeys.TopDistributors],
  },
  manualValue,
  manualValueGlobal,
]
